import type { ReactNode } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthGuard, useAuthContext } from './shared/contexts/AuthContext'
import { AppLayout } from './shared/layout/AppLayout'
import { ApiKeysPage } from './pages/api-keys/ApiKeysPage'
import { AccountsPage } from './pages/accounts/AccountsPage'
import { AccountTransactionsPage } from './pages/account-transactions/AccountTransactionsPage'
import { AuthUsersPage } from './pages/auth-users/AuthUsersPage'
import { DashboardPage } from './pages/dashboard/DashboardPage'
import { EmailsPage } from './pages/emails/EmailsPage'
import { LoginPage } from './pages/login/LoginPage'
import { NotFoundPage } from './pages/error/NotFoundPage'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AuthGuard />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/emails" element={<EmailsPage />} />
          <Route path="/accounts" element={<AdminOnly><AccountsPage /></AdminOnly>} />
          <Route path="/accounts/:id/transactions" element={<AdminOnly><AccountTransactionsPage /></AdminOnly>} />
          <Route path="/api-keys" element={<AdminOnly><ApiKeysPage /></AdminOnly>} />
          <Route path="/auth-users" element={<AdminOnly><AuthUsersPage /></AdminOnly>} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

function AdminOnly({ children }: { children: ReactNode }) {
  const { user } = useAuthContext()
  return user?.role === 'admin' ? children : <Navigate to="/dashboard" replace />
}
